import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Divider, Typography, Modal } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuth } from '@contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { confirm } = Modal;

const Profile = () => {
  const { user, changePassword, logout } = useAuth();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const result = await changePassword(values.oldPassword, values.newPassword);
      if (result.success) {
        message.success(result.message);
        // 先登出，清除登录状态
        await logout();
        // 然后跳转到登录页
        window.location.href = '/';
      } else {
        message.error(result.message);
      }
    } catch (error) {
      message.error('密码修改失败：' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetAccount = () => {
    confirm({
      title: '重置账号',
      content: '确定要将账号密码重置为 admin123 吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        setResetLoading(true);
        try {
          const result = await changePassword('admin123', 'admin123');
          if (result.success) {
            message.success('账号重置成功，请使用新密码 admin123 登录');
            await logout();
            window.location.href = '/';
          } else {
            message.error(result.message);
          }
        } catch (error) {
          message.error('账号重置失败：' + error.message);
        } finally {
          setResetLoading(false);
        }
      }
    });
  };

  return (
    <div>
      <Title level={2} style={{ marginBottom: 24 }}>个人设置</Title>
      <Card
        styles={{
          header: {
            borderBottom: 0,
            padding: '24px 0'
          },
          body: {
            padding: 24
          }
        }}
        style={{
          maxWidth: 600,
          margin: '0 auto',
          borderRadius: 8,
          boxShadow: '0 2px 8px 0 rgba(29,35,41,0.05)'
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <Title level={4}>基本信息</Title>
          <Form layout="vertical">
            <Form.Item label="用户名">
              <Input
                prefix={<UserOutlined style={{ color: '#008d6a' }} />}
                value={user?.username}
                disabled
                style={{ maxWidth: 300 }}
              />
            </Form.Item>
          </Form>
        </div>

        <Divider />

        <div>
          <Title level={4}>修改密码</Title>
          <Form
            form={form}
            name="profile"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            style={{ maxWidth: 400 }}
          >
            <Form.Item
              name="oldPassword"
              label="当前密码"
              rules={[{ required: true, message: '请输入当前密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#008d6a' }} />}
                placeholder="请输入当前密码"
              />
            </Form.Item>

            <Form.Item
              name="newPassword"
              label="新密码"
              rules={[
                { required: true, message: '请输入新密码' },
                { min: 6, message: '密码长度不能小于6位' }
              ]}
            >
              <Input.Password
                prefix={<SafetyOutlined style={{ color: '#008d6a' }} />}
                placeholder="请输入新密码"
              />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="确认新密码"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: '请确认新密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<SafetyOutlined style={{ color: '#008d6a' }} />}
                placeholder="请再次输入新密码"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  background: 'linear-gradient(90deg, #008d6a 0%, #006d52 100%)',
                  border: 'none',
                  marginRight: 16
                }}
              >
                修改密码
              </Button>
              <Button
                type="default"
                icon={<ReloadOutlined />}
                loading={resetLoading}
                onClick={handleResetAccount}
                style={{
                  borderColor: '#008d6a',
                  color: '#008d6a'
                }}
              >
                重置账号
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Card>
    </div>
  );
};

export default Profile; 